import { getMainScreenVisibleEndpoints, setMainScreenVisibleEndpoints, setSpaceMenuVisibleEndpoints, setSpacesLobbyViewVisibleEndpoints, setSpacesManagerLobbyVisibleEndpoints, setSpacesManagerVisibleEndpoints, setSpacesViewVisibleEndpoints } from '../features/base/video-quality/functions';
import {room,Video,CONV_STORAGE, onStage, spacesView, screenShare} from './roomnew';
export default class  Efss{
    constructor() {
        this.forwardedEnpoints=[];
        this.onViewportEndpoints=[];
        this.visibleOnConversation=[];
        this.updateDelay=500;
        this.updateTimeout=0;
        this.sideLastScrollPosition=0;
        this.sideLastWindowSize={width:0,height:0};;
        this.lastConversationsScroll=0;
        this.mainLastScrollPosition=0;
        this.mainLastWindowSize={width:0,height:0};
        this.lastlobbyScroll=0;
        this.lastMenuScroll=0;
        this.lastManagerScroll=0;
        this.lastManagerLobbyScroll=0;
        this.visibleOnLobby=[];
        this.scrollablePanel=$("#spacesPanelScrollable");
    };

    viewPortEnter(id,imediate=false){
        const currentEndpoints=getMainScreenVisibleEndpoints();
        currentEndpoints.push(id);
        setMainScreenVisibleEndpoints(currentEndpoints);
        // if(imediate){
        //     e.updateImediately(imediate);
        // }else{
        //     e.update();
        // }
        // console.log("View port enter:"+id+",imediate:"+imediate,e.forwardedEnpoints);
    };

    viewPortLeave(id){
        const currentEndpoints=getMainScreenVisibleEndpoints();
        let newEndpoints=currentEndpoints.filter(eid=>eid!==id);
        setMainScreenVisibleEndpoints(newEndpoints);
    };

    inViewPortSideVideos(){
        var e=this;
        let sideVideosContainer=$('#sideVideosContainer');
        let parentScrollTop=sideVideosContainer.scrollTop();
        if((Math.abs(parentScrollTop-e.sideLastScrollPosition) < 30 && Math.abs(parentScrollTop-e.sideLastScrollPosition) > 0)
        && ((Math.abs(e.sideLastWindowSize.width-window.innerWidth) < 30 && Math.abs(e.sideLastWindowSize.width-window.innerWidth) > 0)
        || (Math.abs(e.sideLastWindowSize.height-window.innerHeight) < 30 && Math.abs(e.sideLastWindowSize.height-window.innerHeight) > 0))
        ){return;}
        // console.warn("Checking in viewport side videos");
        e.sideLastScrollPosition=parentScrollTop;
        e.sideLastWindowSize.height=window.innerHeight;
        e.sideLastWindowSize.width=window.innerWidth;
        let height=sideVideosContainer.height();
        let viewPortStart=0;
        let viewPortEnd=height;
        let endpointsLeaving=[];
        const currentEndpoints=getMainScreenVisibleEndpoints();

        sideVideosContainer.find(".videoViewContainer").each(function(i,video){
            let pid=$(video).attr('id');
            let elHeight=$(video).outerHeight();
            let elPosition=$(video).offset();
            let isVisible=((elPosition.top+elHeight) >= viewPortStart ) && (elPosition.top <= viewPortEnd);
            if(isVisible && !currentEndpoints.includes(pid)){
                currentEndpoints.push(pid);
            }else if(!isVisible){
                endpointsLeaving.push(pid);
            }
        });

        const newEndpoints=currentEndpoints.filter(eid=>!endpointsLeaving.includes(eid));
        setMainScreenVisibleEndpoints(newEndpoints);
        // e.onViewportEndpoints=newEndpoints;
        // e.update();

    };

    inViewPortMainVideos(){
        var e=this;
        let remoteVideosContainer=$('#remoteVideosContainer');
        let remoteVideosWrapper=$("#remoteVideos");
        let parentScrollTop=remoteVideosWrapper.scrollTop();

        if((Math.abs(parentScrollTop-e.mainLastScrollPosition) < 30 && Math.abs(parentScrollTop-e.mainLastScrollPosition) > 0)
         && ((Math.abs(e.mainLastWindowSize.width-window.innerWidth) < 30 && Math.abs(e.mainLastWindowSize.width-window.innerWidth) > 0)
         || (Math.abs(e.mainLastWindowSize.height-window.innerHeight) < 30 && Math.abs(e.mainLastWindowSize.height-window.innerHeight) > 0))
         ){
            return;}

        e.mainLastScrollPosition=parentScrollTop;
        e.mainLastWindowSize.height=window.innerHeight;
        e.mainLastWindowSize.width=window.innerWidth;
        let height=remoteVideosWrapper.height();
        let viewPortStart=0;
        let viewPortEnd=height;
        let endpointsLeaving=[];
        const currentEndpoints=getMainScreenVisibleEndpoints();

        remoteVideosContainer.find(".videoViewContainer").each(function(i,video){
            let pid=$(video).attr('id');
            if(pid=="localParticipant"){return}
            let elHeight=$(video).outerHeight();
            let elPosition=$(video).offset();
            let isVisible=((elPosition.top+elHeight) >= viewPortStart ) && (elPosition.top <= viewPortEnd);
            if(isVisible && !currentEndpoints.includes(pid)){
                currentEndpoints.push(pid);
            }else if(!isVisible){
                endpointsLeaving.push(pid);
            }
        });
        const newEndpoints=currentEndpoints.filter(eid=>!endpointsLeaving.includes(eid));
        setMainScreenVisibleEndpoints(newEndpoints);
        // e.onViewportEndpoints=newEndpoints;
        // e.update();
    };

    inViewPortAudienceVideos(){
        var e=this;
        let remoteVideosContainer=$('#remoteVideosContainer');
        // let remoteVideosWrapper=$("#remoteVideos");
        if(!onStage.myStage.audienceScrollable){
            return;
        }
        let parentScrollTop=onStage.myStage.audienceScrollable.scrollTop();

        if((Math.abs(parentScrollTop-e.mainLastScrollPosition) < 30 && Math.abs(parentScrollTop-e.mainLastScrollPosition) > 0)
         && ((Math.abs(e.mainLastWindowSize.width-window.innerWidth) < 30 && Math.abs(e.mainLastWindowSize.width-window.innerWidth) > 0)
         || (Math.abs(e.mainLastWindowSize.height-window.innerHeight) < 30 && Math.abs(e.mainLastWindowSize.height-window.innerHeight) > 0))
         ){
            return;}

        console.warn("Checking in viewport Audience videos");
        e.mainLastScrollPosition=parentScrollTop;
        e.mainLastWindowSize.height=window.innerHeight;
        e.mainLastWindowSize.width=window.innerWidth;
        let height=onStage.myStage.audienceScrollable.height();
        let viewPortStart=0;
        let viewPortEnd=height;
        let endpointsLeaving=[];
        const currentEndpoints=getMainScreenVisibleEndpoints();
        remoteVideosContainer.find(".videoViewContainer").each(function(i,video){
            let pid=$(video).attr('id');
            if(pid=="localParticipant"){return}
            let elHeight=$(video).outerHeight();
            let elPosition=$(video).offset();
            let isVisible=((elPosition.top+elHeight) >= viewPortStart ) && (elPosition.top <= viewPortEnd);
            if(isVisible && !currentEndpoints.includes(pid)){
                currentEndpoints.push(pid);
            }else if(!isVisible){
                endpointsLeaving.push(pid);
            }
        });
        const newEndpoints=currentEndpoints.filter(eid=>!endpointsLeaving.includes(eid));
        setMainScreenVisibleEndpoints(newEndpoints);
        // e.onViewportEndpoints=newEndpoints;
        // e.update();
    };

    isInViewPort(el,parent,pid,forceSend=false){
        var e=this;
        if(pid=="localParticipant"){return}
        let elHeight=el.outerHeight();
        let elPosition=el.offset();
        let parentHeight=parent.height();
        let parentScrollTop=parent.scrollTop();
        let viewPortStart=0;
        let viewPortEnd=parentHeight;
        if(parent.attr('id')=="remoteVideos"){
            //console.warn("Main Screen participant****************************************");
        }
        const currentEndpoints=getMainScreenVisibleEndpoints();
        console.log(`CHECKING IF VIDEO IS IN VIEWPORT: Top poition=${elPosition.top},Height:${elHeight}, currentEndpoints`,currentEndpoints);
        let isVisible=((elPosition.top+elHeight) >= viewPortStart ) && ( elPosition.top <= viewPortEnd);
        if(isVisible && !currentEndpoints.includes(pid)){
            e.viewPortEnter(pid,forceSend);
        }else if(!isVisible && currentEndpoints.includes(pid)){
            e.viewPortLeave(pid);
        }
    };

    inViewPortConversations(scrolling=false){
        var e=this;
        this.scrollablePanel = spacesView.isOpen() ? $("#expanedViewSpacesContainerId") : $("#spacesPanelScrollable");
        var scrollTop=this.scrollablePanel.scrollTop();
        console.log("Spaces Scrolling",scrolling);
        if(scrolling && Math.abs(scrollTop-e.lastConversationsScroll) < 30){return}
        // var convoPanel=spacesView.spacesRow;
        let panelHeight= this.scrollablePanel.height();
        let containerOffset = this.scrollablePanel[0].offsetTop;
        let viewPortStart = Math.max(scrollTop,0) + containerOffset;
        let viewPortEnd = viewPortStart+panelHeight;

        let inViewport=[];
        if(!spacesView.isOpen()){
            const lobbySpaceContainer = this.scrollablePanel.find("#expanedViewLobbyContainerId");
            //check if lobby is in viewport
            const lobbyPosition=lobbySpaceContainer[0].offsetTop;
            const lobbyElHeight=lobbySpaceContainer.height() + 16;
            let isLobbyVisible=((lobbyPosition+lobbyElHeight) >= viewPortStart ) && (lobbyPosition <= viewPortEnd);
            console.log(`Spaces Lobby: start ${viewPortStart} end ${viewPortEnd},scrollTop=${scrollTop} offsetTop:${containerOffset},box h ${lobbyElHeight}, position`,lobbyPosition);
            if(isLobbyVisible){
                console.log("Lobby is visible");
                lobbySpaceContainer.find('video').each((i,video)=>{
                    const lobbyPid = $(video).attr('pid')
                    if(!inViewport.includes(lobbyPid)) inViewport.push(lobbyPid);
                });
                console.log("Lobby participants",inViewport);
            }
        }
        $.each(CONV_STORAGE.conversations,function(cid,convo){
            if(convo.participants.length == 0){
                return;
            }
            // console.log("check convo for efss",convo)
            let position=convo.container[0].offsetTop;
            let elHeight=convo.container.height() + 16;
            // console.log(`Spaces VP: start ${viewPortStart} end ${viewPortEnd},scrollTop=${scrollTop} offsetTop:${containerOffset},box h ${elHeight}, position`,position);
            // console.log("container offset",containerOffset);
            // console.log(`Space position ${position} - ${position+elHeight}`,isVisible);
            let isVisible=((position+elHeight) >= viewPortStart ) && (position <= viewPortEnd);
            console.log("Space "+convo.name+" is visible",isVisible);
            if(isVisible){
                convo.container.find('video').each((i,video)=>{
                    const spacepid = $(video).attr('pid')
                    if(!inViewport.includes(spacepid)) inViewport.push(spacepid);
                });
            }
            //console.log(convo.name,convo.htmlElement.offset());
        });

        //get lobby view port
        console.log("In viewport participants ",inViewport);
        setSpacesViewVisibleEndpoints(new Array(...inViewport));
        // e.visibleOnConversation=new Array(...inViewport);
        // spacesView.setInSpaceThumbnailResolution();
        // e.update();
        // console.log(e.visibleOnConversation);
    };

    visibleLobby(scrolling=false){
        var scrollTop=spacesView.lobbyTileContainer.scrollTop();
        if(scrolling && Math.abs(scrollTop-this.lastlobbyScroll) < 30){return}
        this.lastlobbyScroll=scrollTop;
        let panelHeight=spacesView.spacesRow.height();
        let viewPortStart=scrollTop;
        let viewPortEnd=viewPortStart+panelHeight;
        let inViewport=[];
        spacesView.lobbyTileContainer.find("div.participant-video-container").each((i,thumb)=>{
            let el=$(thumb);
            let position=el[0].offsetTop;
            let elHeight=el.height();
            console.log(`Thumb ${viewPortEnd},scrollTop=${scrollTop} space height ${elHeight}, position`,position);
            let isVisible=((position+elHeight) >= viewPortStart ) && (position <= viewPortEnd);
            if(isVisible){
                let pid=el.attr('pid');
                if(pid && (pid!=room.myUserId())){
                    inViewport.push(pid);
                }
            }
        });
        // this.visibleOnLobby=new Array(...inViewport);
        setSpacesLobbyViewVisibleEndpoints(new Array(...inViewport));
        // spacesView.setInSpaceThumbnailResolution();
        // this.update();
        // console.log("Visible on lobby",this.visibleOnLobby);
    };

    inViewportLobby(scrolling=false){
        const menuScrollable = spacesView.isOpen() ? $("#lobby-space-body") : null
        if(!menuScrollable){return}
        var scrollTop=menuScrollable.scrollTop();
        if(scrolling && Math.abs(scrollTop-this.lastMenuScroll) < 30){return}
        this.lastMenuScroll=scrollTop;
        let panelHeight=menuScrollable.height();
        let containerOffset = menuScrollable[0].offsetTop;
        let viewPortStart= Math.max(scrollTop,0) + containerOffset;
        let viewPortEnd=viewPortStart+panelHeight;
        let inViewport=[];

        menuScrollable.find("div.participant-video-container").each((i,thumb)=>{
            let el=$(thumb);
            let position=el[0].offsetTop;
            let elHeight=el.height() + 24;
            console.log(`LOBBY VP: start ${viewPortStart} end ${viewPortEnd},scrollTop=${scrollTop} offsetTop:${containerOffset},box h ${elHeight}, position`,position);
            console.log("container offset",containerOffset);
            let isVisible=((position+elHeight) >= viewPortStart ) && (position <= viewPortEnd);
            console.log(`Participant position ${position} - ${position+elHeight}`,isVisible);
            if(isVisible){
                let pid=el.attr('pid');
                if(pid && (pid!=room.myUserId())){
                    if(!inViewport.includes(pid)) inViewport.push(pid);
                }
            }
        });
        console.log("Space Lobby in viewport",inViewport);
        setSpacesLobbyViewVisibleEndpoints(new Array(...inViewport));
    };

    inViewportSpaceMenu(scrolling=false){
        const menuScrollable = spacesView.isOpen() ? $(spacesView.expandedOpenedMenu).find('.menu-body') : $("#left-menu-participants")
        if(!menuScrollable){return}
        var scrollTop=menuScrollable.scrollTop();
        if(scrolling && Math.abs(scrollTop-this.lastMenuScroll) < 30){return}
        this.lastMenuScroll=scrollTop;
        let panelHeight=menuScrollable.height();
        let containerOffset = menuScrollable[0].offsetTop;
        let viewPortStart= Math.max(scrollTop,0) + containerOffset;
        let viewPortEnd=viewPortStart+panelHeight;
        let inViewport=[];

        menuScrollable.find("div.menu-container").each((i,thumb)=>{
            let el=$(thumb);
            let position=el[0].offsetTop;
            let elHeight=el.height() + 24;
            console.log(`MENU VP: start ${viewPortStart} end ${viewPortEnd},scrollTop=${scrollTop} offsetTop:${containerOffset},box h ${elHeight}, position`,position);
            console.log("container offset",containerOffset);
            let isVisible=((position+elHeight) >= viewPortStart ) && (position <= viewPortEnd);
            console.log(`Participant position ${position} - ${position+elHeight}`,isVisible);
            if(isVisible){
                let pid=el.find('video').attr('pid');
                if(pid && (pid!=room.myUserId())){
                    if(!inViewport.includes(pid)) inViewport.push(pid);
                }
            }
        });
        console.log("Space menu in viewport",inViewport);
        setSpaceMenuVisibleEndpoints(new Array(...inViewport));
    };

    inViewportSpaceManager(scrolling=false){
        const managerSpacesScrollable = $("#pills-manual .accordion-container-split-convo");
        if(!managerSpacesScrollable){return}
        var scrollTop=managerSpacesScrollable.scrollTop();
        if(scrolling && Math.abs(scrollTop-this.lastManagerScroll) < 30){return}
        this.lastManagerScroll=scrollTop;
        let panelHeight=managerSpacesScrollable.height();
        let containerOffset = managerSpacesScrollable[0].offsetTop;
        let viewPortStart= Math.max(scrollTop,0) + containerOffset;
        let viewPortEnd=viewPortStart+panelHeight;
        let inViewport=[];

        managerSpacesScrollable.find("#conversation-list div.card").each((i,thumb)=>{
            let el=$(thumb);
            let position=el[0].offsetTop;
            let elHeight=el.height();
            console.log(`SPACES MANAGER VP: start ${viewPortStart} end ${viewPortEnd},scrollTop=${scrollTop} offsetTop:${containerOffset},box h ${elHeight}, position`,position);
            console.log("container offset",containerOffset);
            let isVisible=((position+elHeight) >= viewPortStart ) && (position <= viewPortEnd);
            console.log(`Participant position ${position} - ${position+elHeight}`,isVisible);
            if(isVisible){
                el.find('div.draggable-participant').each((i,tile)=>{
                    const pid = $(tile).attr('participant-id');
                    if(pid && (pid!=room.myUserId())){
                        if(!inViewport.includes(pid)) inViewport.push(pid);
                    }
                })
            }
        });
        console.log("Space Manager in viewport",inViewport);
        setSpacesManagerVisibleEndpoints(new Array(...inViewport));
    };

    inViewportSpaceManagerLobby(scrolling=false){
        const managerSpacesScrollable = $("#spl-participant-list");
        if(!managerSpacesScrollable){return}
        var scrollTop=managerSpacesScrollable.scrollTop();
        if(scrolling && Math.abs(scrollTop-this.lastManagerLobbyScroll) < 30){return}
        this.lastManagerLobbyScroll=scrollTop;
        let panelHeight=managerSpacesScrollable.height();
        let containerOffset = managerSpacesScrollable[0].offsetTop;
        let viewPortStart= Math.max(scrollTop,0) + containerOffset;
        let viewPortEnd=viewPortStart+panelHeight;
        let inViewport=[];

        managerSpacesScrollable.find("li.participant-item").each((i,thumb)=>{
            let el=$(thumb);
            let position=el[0].offsetTop;
            let elHeight=el.height();
            console.log(`SPACES MANAGER LOBBY VP: start ${viewPortStart} end ${viewPortEnd},scrollTop=${scrollTop} offsetTop:${containerOffset},box h ${elHeight}, position`,position);
            console.log("container offset",containerOffset);
            let isVisible=((position+elHeight) >= viewPortStart ) && (position <= viewPortEnd);
            console.log(`Participant position ${position} - ${position+elHeight}`,isVisible);
            if(isVisible){
                let pid=el.attr('participant-id');
                if(pid && (pid!=room.myUserId())){
                    if(!inViewport.includes(pid)) inViewport.push(pid);
                }
            }
        });
        console.log("Space Manager LOBBY in viewport",inViewport);
        setSpacesManagerLobbyVisibleEndpoints(new Array(...inViewport));
    };

    clearInViewConversations(){
        // var e=this;
        setSpacesViewVisibleEndpoints([]);
        // e.update();
    }
    clearVisibleOnLobby(){
        setSpacesLobbyViewVisibleEndpoints([]);
        // this.update();
    }
    update(){
        if(!Video){return}
        var e=this;
        if(!e.updateTimeout){
            e.updateTimeout=setTimeout(() => {
                clearTimeout(e.updateTimeout);
                e.updateTimeout=0;
                if(e.onViewportEndpoints.length==0){
                    e.sendEndpoints([]);
                }else{
                    //console.log("Forwarded:",e.forwardedEnpoints);
                    //console.log("OnViewport:",e.onViewportEndpoints);
                    let skipEfssEndpoints=[];
                    for (const eid in Video.videos) {
                        if(Video.videos[eid].skipEfss){
                            skipEfssEndpoints.push(eid);
                        }
                    }
                    let onStageWithMe=[];
                    if(onStage.isActive() && onStage.myStage.isStageView()){
                        try {
                            onStageWithMe=onStage.participants.filter(pid=>pid!=room.myUserId());
                        } catch (error) {

                        }
                    }
                    let screenSharePopup=[];
                    if(screenShare.popup.isOpen()){
                        screenSharePopup=screenShare.popup.visibleVideos;
                    }
                    let onViewportEndpoints=[...new Set([...e.onViewportEndpoints,...e.visibleOnConversation,...skipEfssEndpoints,...onStageWithMe,...e.visibleOnLobby,...screenSharePopup])];
                    //console.log(onViewportEndpoints);
                    let difference=onViewportEndpoints.filter(eid=>!e.forwardedEnpoints.includes(eid));

                    if(difference.length==0 && onViewportEndpoints.length==e.forwardedEnpoints.length){
                        //console.warn("Update cancelled because there is no change on forwarded endpoints");
                        return;}
                    if(Object.keys(Video.videos).length==onViewportEndpoints.length){
                        e.sendEndpoints([]);
                    }else{
                        e.sendEndpoints(onViewportEndpoints);
                    }

                }
            }, e.updateDelay);
        }else{
            //console.warn("Update is not posible because of delay",e.updateTimeout);
        }

    };
    updateImediately(force=false){

        var e=this;
        console.error("Update imediately",e.onViewportEndpoints);
                if(e.onViewportEndpoints.length==0){
                    e.sendEndpoints([]);
                }else{
                    let onViewportEndpoints=[...new Set([...e.onViewportEndpoints,...e.visibleOnConversation])];
                    let difference=onViewportEndpoints.filter(eid=>!e.forwardedEnpoints.includes(eid));

                    if(difference.length==0 && onViewportEndpoints.length==e.forwardedEnpoints.length && !force){return;}
                    if(Object.keys(Video.videos).length==e.onViewportEndpoints.length){
                        e.sendEndpoints([]);
                    }else{
                        e.sendEndpoints(onViewportEndpoints);
                    }

                }
    }

    sendEndpoints(endpoints){
        var e=this;
        // efss disabled
    //    try{
    //          if(room.rtc._channel && room.rtc._channel.isOpen()){
    //             // console.error("SENDING NEW ENDPOINTS TO KVB",endpoints);
    //             room.rtc._channel._send({
    //                 colibriClass: 'ForwardEndpointsMessage',
    //                 forwardEndpoints: endpoints
    //             });

    //             e.forwardedEnpoints=new Array(...endpoints);
    //             console.warn("FORWARDED ENDPOINTS CHANGED",e.forwardedEnpoints);
    //         }else{
    //             //console.log("_channel error");
    //             //console.log(room.rtc);
    //             console.error("SENDING NEW ENDPOINTS TO KVB NO OPEN CHANNEL",endpoints);

    //         }
    //     }catch(error){
    //         console.error(error);
    //     }
    };


};
